import React from 'react'

/**
 * §9 banner shown when the database management service returns 503.
 *
 * Why this exists separately from generic toast/error UI:
 *   - 503 from `/api/client/databases` means the DatabaseAdminService
 *     env-gate is off (e.g. operator hasn't enabled the host MariaDB
 *     plane yet). Existing databases continue to run; only the
 *     management UI is paused.
 *   - The user must NEVER see "Failed to fetch" / "Server error
 *     500" / a raw status code — that's a §9 violation.
 *
 * Wording mirrors the operator-friendly text in the user manual.
 */

export const ServiceUnavailableBanner: React.FC = () => (
  <div
    data-testid="db-service-unavailable"
    role="status"
    className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4 sm:p-5"
  >
    <h3 className="text-sm sm:text-base font-semibold text-amber-900 dark:text-amber-200">
      Database Service Temporarily Unavailable
    </h3>
    <p className="mt-1 text-sm text-amber-800 dark:text-amber-300">
      The database management service is starting up or undergoing
      maintenance. Existing databases continue to run; only the
      management UI is paused. Try again in a moment.
    </p>
  </div>
)
